import * as zip from '@zip.js/zip.js';

import { getBaseFilename, getFileExtension } from '../utilities/fileProcessingUtilities';
import { UploadedFile } from './UploadedFile';

export class FileFromZip implements UploadedFile {
  source: zip.FileEntry;

  filetype: string | null;
  filename: string;

  contents?: string;

  constructor(source: zip.FileEntry) {
    this.source = source;

    this.filename = getBaseFilename(source.filename);
    this.filetype = getFileExtension(source.filename);
  }

  async getContents(): Promise<string> {
    if (!this.contents) {
      this.contents = await this.source.getData(new zip.Data64URIWriter());
    }

    return this.contents;
  }
}
